import { HTMLAttributes } from 'react';
import styles from './selectable.module.css';
import { ChevronRightIcon } from '@heroicons/react/24/solid';

export const Selectable = ({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={`${styles.selectable} ${className}`} {...props}>
      <div className="selectable__content">{children}</div>
      <ChevronRightIcon height={24} />
    </div>
  );
};
